'use client';

import { useEffect } from 'react';
import NextError from 'next/error';

import { cLogger } from '@/common/lib/logger/client';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    cLogger.error(error);
  }, [error]);

  return (
    <html translate="no">
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
